import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {pinnedArticle, pinnedArticles_template} from "./pinnedArticles_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {HubPageSearchResult} from "../../utils/types/listing_page";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { imageWidget_template } from "./imageWidget_template";

declare var ko: any;

export class configHomePage_template extends vnTemplate{

    public pinnedArticles: pinnedArticles_template;
    public filterListingPageTemplate: filterListingPage_template;
    public filterSowMoreListingPageTemplate: filterListingPage_template;
    protected filterSidebarLinksListingPage: filterListingPage_template;
    protected filterSidebarLinksArticle: filterAutocomplete_template;
    protected filterSectionType: filterDropdown_template;
    protected sectionTypes: any;

    public listingPageFilter: filterListingPage_template;
    public showMoreListingPageFilter: filterListingPage_template;
    public imagePicker: imagePicker_template;
    protected imagePickerHelper: imagePickerHelper;
    public imageWidget: imageWidget_template;

    protected getTemplateHtml(): string{

        return `
            <div class="w-form">
               <div class="form-header">
                  <input type="hidden">
                  <h3 class="form-title">Home page</h3>
               </div>


               <div class="form-body">

                   <h3 class="form-sub-title icon i-article">Pinned articles</h3>
                   <div class="form-group">
                        `+ this.pinnedArticles.getHtmlBuild() +`
                   </div>


                    <h3 class="form-sub-title icon i-listing-page">Pinned Hub Pages (Featured Section)</h3>
                    <div class="form-group">
                        <button data-bind="enable: addFeaturedListingPageEnabled, event: { click: onClickToggleListingPagePinnedSection.bind($data, 'featured', true, false) }" class="btn highlight" type="button">Add As Featured Section</button>
                    </div>
                    <div class="form-group">
                        <div class="form-body w-pinned" data-bind="foreach: pinnedListingPages">
                            <!-- ko if: $data.type == "featured" -->
                            <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">

                                <div class="pinned-drag icon i-drag">
                                <span class="pinned-position">1</span>
                                </div>

                                <div class="w-btn" data-bind="visible: !enableEdit">
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>

                                <div class="w-title">
                                <div>
                                    <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                </div>
                                <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>

                                <div class="last">
                                <label class="form-label icon i-overwrite"></label>
                                <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                                </div>

                                <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;margin-bottom: 1rem">
                                        <div>
                                        <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                        </div>
                                    </div>
                                </div>

                                <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;">
                                        <div>
                                            <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>
                    </div>


                   <h3 class="form-sub-title icon i-listing-page">Pinned Hub Pages (2-Hub Preview)</h3>
                   <div class="form-group">
                       <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'hubPreview', true, false) }" class="btn highlight" type="button">Add As 2-Hub Preview</button>
                   </div>
                   <div class="form-group" data-bind="visible: tagTrendingLogicConfig() != null && tagTrendingLogicConfig().id_tag_types && tagTrendingLogicConfig().id_tag_types.length > 0">
                        <input type="checkbox" id="isDbPageRatingEnabled" data-bind="checked: isDbPageRatingEnabled">
                        <label for="isDbPageRatingEnabled" class="form-label icon i-check">DB Page Rating</label>
                   </div>
                   <div class="form-group " data-bind="foreach: pinnedHubPagesPreview, childrenComplete : handleDragAndDrop($element, pinnedHubPagesPreview ,'.entry')">
                       <div class="form-body w-pinned">
                           <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">
                                <div class="pinned-drag icon i-drag">
                                   <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn" data-bind="visible: !enableEdit">
                                   <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedListing }"><span class="hidden-text">Edit</span></button>
                                   <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                                <div class="last">
                                    <label class="form-label icon i-overwrite"></label>
                                    <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                    <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                                </div>
                                <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;margin-bottom: 1rem">
                                        <div>
                                           <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                        </div>
                                    </div>
                                </div>
                                <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;">
                                        <div>
                                            <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                        </div>
                                    </div>
                                 </div>
                           </div>
                       </div>
                    </div>

                    <div data-bind="visible: isDbPageRatingEnabled">
                        <h3 class="form-sub-title icon i-article">Pinned DB Listing Pages</h3>
                        <div class="form-group">
                            <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'hubRating', true, false) }" class="btn highlight" type="button">Add DB Page</button>
                        </div>
                        <div class="form-group " data-bind="foreach: pinnedDbPages, childrenComplete : handleDragAndDrop($element, pinnedDbPages ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: idTags[0]"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>


                    <h3 class="form-sub-title icon i-listing-page">Pinned Hub Pages (5-Article Preview)</h3>
                    <div class="form-group">
                        <button data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, null, true, false) }" class="btn highlight" type="button">Add As 5-Article Preview</button>
                    </div>
                    <div class="form-group">
                        <div class="form-body w-pinned" data-bind="foreach: pinnedListingPages, childrenComplete : handleDragAndDrop($element, pinnedListingPages ,'.entry')">
                            <!-- ko if: $data.type !== "featured" -->
                            <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">

                                    <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                    </div>

                                    <div class="w-btn" data-bind="visible: !enableEdit">
                                    <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedListing }"><span class="hidden-text">Edit</span></button>
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                    </div>

                                    <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                    </div>

                                    <div class="last">
                                    <label class="form-label icon i-overwrite"></label>
                                    <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                    <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                                    </div>

                                    <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                        <div class="border" style="width: 100%;margin-bottom: 1rem">
                                            <div>
                                            <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                        <div class="border" style="width: 100%;">
                                            <div>
                                                <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <!-- /ko -->
                        </div>
                    </div>


                   <h3 class="form-sub-title icon i-listing-2-preview">Pinned Hub Pages (Full List Tab)</h3>
                   <div class="form-group">
                       <button data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, 'fullList', true, true) }" class="btn highlight" type="button">Add As Full List Tab</button>
                   </div>
                   <div class="form-group " data-bind="foreach: fullListPinnedListingPages, childrenComplete : handleDragAndDrop($element, fullListPinnedListingPages ,'.entry')">
                       <div class="form-body w-pinned">
                           <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">
                                <div class="pinned-drag icon i-drag">
                                   <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn" data-bind="visible: !enableEdit">
                                   <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedListing }"><span class="hidden-text">Edit</span></button>
                                   <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                                <div class="last">
                                    <label class="form-label icon i-overwrite"></label>
                                    <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                    <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                                </div>
                                <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;margin-bottom: 1rem">
                                        <div>
                                           <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                        </div>
                                    </div>
                                </div>
                                <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;">
                                        <div>
                                            <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                        </div>
                                    </div>
                                 </div>
                           </div>
                       </div>
                   </div>
               </div>

               <h3 class="form-sub-title icon i-listing-2-preview">DB Home Spotlight Section</h3>
               <div data-bind="visible: isDbSpotlightEnabled">
                    <h3 class="form-sub-title icon i-article">DB Home Spotlight</h3>
                    <div class="form-group">
                        <label class="form-label" for="article">Title</label>
                        <input class="input-text" type="text" id="spotlightTitle" name="spotlightTitle" data-bind="value: spotlightTitle">
                    </div>
                    <div class="form-group">
                        <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'homeSpotlight', true, false) }" class="btn highlight" type="button">Add DB Page</button>
                    </div>
                    <div class="form-group " data-bind="foreach: pinnedDbHomeSpotlightPages, childrenComplete : handleDragAndDrop($element, pinnedDbHomeSpotlightPages ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: idTags[0]"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 class="form-sub-title icon i-listing-2-preview">Pinned Custom Cards (Featured Section)</h3>
                <div class="form-group" >
                    <input id="activatePinnedCustomCards" name="activatePinnedCustomCards" type="checkbox" data-bind="checked: activatePinnedCustomCards">
                    <label for="activatePinnedCustomCards" class="form-label icon i-check">Activate Widget</label>
                </div>
                <div class="form-group" data-bind="visible: activatePinnedCustomCards()">
                    <div class="form-group">
                        <label class="form-label" for="customCardsSectionTitle" >Section Title</label>
                        <input type="text" id="customCardsSectionTitle" class="input-text" data-bind="value: customCardsSectionTitle">
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="" >More Linkout</label>
                        <input type="text" placeholder="Title" id="customCardsMoreLinkoutTitle" class="input-text" data-bind="value: customCardsMoreLinkoutTitle">
                        <input type="text" placeholder="URL" id="customCardsMoreLinkoutUrl" class="input-text" data-bind="value: customCardsMoreLinkoutUrl">
                    </div>
                    <div class="form-group">
                       <button data-bind="event: { click: onClickTogglePinnedCustomCardSection(true) }" class="btn highlight" type="button">Add Pinned Custom Card</button>
                    </div>
                    <div class="form-group " data-bind="foreach: pinnedCustomCardItems, childrenComplete : handleDragAndDrop($element, pinnedCustomCardItems ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedCustomCardItem }"><span class="hidden-text">Edit</span></button>
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedCustomCardItem }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <span class="pinned-title">Card Title :<span data-bind="text: cardTitle"></span></span>
                                    <span class="pinned-title">Card Linkout :<span data-bind="text: cardLinkoutUrl"></span></span>
                                    <!-- ko if: cardImage && cardImage.url -->
                                    <div class="pinned-title"> Card Image:
                                        <img data-bind="attr: { src: cardImage.url + '?w=50&h=50', alt: cardImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                    </div>
                                    <!-- /ko -->
                                    <span class="pinned-title">Card Description :<span data-bind="html: cardDescription"></span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


               <div class="form-footer">
                  <button data-bind="event: { click: onClickCancelHomePageConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                  <button data-bind="event: { click: onClickSaveHomePageConfig }" class="btn highlight" type="button">Save</button>
               </div>
               
            </div>

            <!-- sidebar-featured-links FE-->
            <div class="w-form sidebar-featured-links">
                <div class="form-header">
                    <h3 class="form-title icon">Pinned Sidebar Sections</h3>
                    <button class="btn icon i-plus" data-bind="event: { click: onClickShowSectionModal }" type="button">ADD SECTION</button>
                </div>
                 <div class="drag-handles section-sortable">
                     <div class="form-body">

                        <div class="form-group">
                            <label class="form-label" for="test1" >Tab Title</label>
                            <input type="text" id="test1" class="input-text" data-bind="value: sidebarSectionTabTitle">
                        </div>

                        <!-- ko foreach: sidebarSections -->
                        <div data-bind="css: { dragging: dragging },
                                                   dragZone: { name: 'section-sortable',
                                                     dragStart: $parent.dragStart,
                                                     dragEnd: $parent.dragEnd
                                                   },
                                                   dragEvents: {
                                                     accepts: 'section-sortable',
                                                     dragOver: $parent.reorderSortable,
                                                     data: { items: $parent.sidebarSections, item: $data }
                                                   }">
                            <button class="btn icon i-move i-drag drag-handle featured-title" data-bind="event: { click: $parent.onClickSetActiveSection.bind($data, $index()) }, css: { 'is-activated' : $index() == $parent.activeSection()}" type="button"><span class="btn-text" data-bind="text: $data.value.sectionTitle"></span></button>
                            <div class="form-body featured-content" data-bind="css: { 'is-hidden' : $index() != $parent.activeSection()} ">
                                <table class="list-action">
                                    <thead>
                                        <tr class="no-border">
                                            <th class="align-left" colspan="4">
                                                <h3 class="section-title" data-bind="text: $data.value.sectionTitle"></h3>
                                                <h3 class="section-title alt" data-bind="text: $data.value.sectionTypeTitle"></h3>
                                            </th>
                                            <th class="align-right no-border">
                                                <button class="btn border small only-icon icon i-edit" data-bind="event: { click: $parent.onClickEditSection }" type="button"></button>
                                                <button class="btn border small only-icon icon i-delete" data-bind="event: { click: $parent.onClickDeleteSection }" type="button"></button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: $data.value.links" class="drag-handles sortable">
                                         <tr data-bind="css: { dragging: dragging },
                                                   dragZone: { name: 'sortable',
                                                     dragStart: $parents[1].dragStart,
                                                     dragEnd: $parents[1].dragEnd
                                                   },
                                                   dragEvents: {
                                                     accepts: 'sortable',
                                                     dragOver: $parents[1].reorderSortable,
                                                     data: { items: $parent.value.links, item: $data }
                                                   }">
                                                <td class="drag-handle i-move align-center no-border width-reduce">
                                                    <button class="btn no-bg small only-icon icon i-drag"></button>
                                                </td>
                                                <td class="no-border align-left" colspan="3">
                                                    <table>
                                                        <tr><td>TYPE:</td><td><span data-bind="text: value.type"></span></td></tr>
                                                        <tr><td>TITLE:</td><td><span data-bind="text: value.title"></span></td></tr>
                                                        <tr><td>ALT TITLE:</td><td><span data-bind="text: value.alternateTitle"></span></td></tr>
                                                    </table>
                                                </td>
                                                <td class="no-border align-right no-wrap">
                                                    <button data-bind="event: { click: $parents[1].onClickEditLink }" class="btn border small only-icon icon i-edit"></button>
                                                    <button data-bind="event: { click: $parents[1].onClickDeleteLink }" class="btn border small only-icon icon i-delete"></button>
                                                </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="form-group w-add-item">
                                    <button type="button" class="btn dark icon i-plus"  data-bind="event: {click : $parent.onClickShowItemModal}">Add Item</button>
                                </div>
                            </div>
                        </div>

                        <!-- /ko -->
                     </div>
                </div>
                <div class="form-footer">
                  <button  title="There will be no changes made" class="btn " type="button">Cancel</button>
                  <button  class="btn highlight" data-bind="event: { click: onClickSaveSidebarFeaturedLinks }" type="button">Save</button>
                </div>


            </div>

            <div class="new-section-pop-up w-lightbox light-theme" data-bind="css: { 'is-visible': isSectionDialogVisible }" id="section-popup">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-listing-page">New Section</h3>
                            <button class="close-button icon i-close-2" data-bind="event: {click : onClickCancelSectionEdit}" type="button"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label" for="test1" >Section Title</label>
                                <input type="text" id="test1" class="input-text" data-bind="textInput: sectionTitle">
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="test1" >Section Type</label>
                                ${this.filterSectionType.getHtmlBuild()}
                            </div>
                        </div>
                        <div class="form-footer">
                          <button  title="There will be no changes made" class="btn" data-bind="event: {click : onClickCancelSectionEdit}" type="button">Cancel</button>
                          <button  class="btn highlight" type="button" data-bind=" enable: sectionTitle , event: { click: onClickSaveSection  }">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="add-item-pop-up w-lightbox light-theme" data-bind="css: { 'is-visible': isItemDialogVisible }" id="item-popup">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-listing-page">ADD NEW ITEM</h3>
                            <button class="close-button icon i-close-2" data-bind="event: {click : onClickCancelLinkEdit}" type="button"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <div class="form-check-inline width-auto">
                                   <input type="radio" id="article" name="radio-group" value="article" data-bind="checked: linkType">
                                   <label  for="article">Article</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                   <input type="radio" id="listing-page" name="radio-group" value="listing_page" data-bind="checked: linkType">
                                   <label for="listing-page">Listing Page</label>
                                </div>
                            </div>
                            <div class="form-group">
                                    <!-- ko if: linkType() == 'listing_page' -->
                                   ${this.filterSidebarLinksListingPage.getHtmlBuild()}
                                   <!-- /ko -->
                                   <!-- ko if: linkType() == 'article' -->
                                   ${this.filterSidebarLinksArticle.getHtmlBuild()}
                                   <!-- /ko -->
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="article">Alternate Title</label>
                                <input class="input-text" type="text" id="alternatTitle" name="alternateTitle" data-bind="value: alternateTitle">
                            </div>
                        </div>
                        <div class="form-footer">
                          <button  title="There will be no changes made" class="btn" data-bind="event: { click: onClickCancelLinkEdit }" type="button">Cancel</button>
                          <button  class="btn highlight" type="button" data-bind="enable: linkType() && (filterSidebarLinksListingPage.listingPageObj() || filterSidebarLinksArticle.optionObj()) ,event: { click: onClickAddLink }">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isLinkDeleteVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Confirm deletion of link</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">Do you confirm the deletion of this item?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickConfirmLinkDelete}" class="btn highlight">Confirm</button>
                                <button type="button" data-bind="event: { click: onClickCancelLinkDelete}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>
            </div>

            <div data-bind="css: { 'is-visible': isSectionDeleteVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Confirm deletion of section</h3>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Do you confirm the deletion of this item?</p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickConfirmSectionDelete}" class="btn highlight">Confirm</button>
                            <button type="button" data-bind="event: { click: onClickCancelSectionDelete}" class="btn ">Cancel</button>
                        </div>
                    </div>

                </div>
            </div>

            <div data-bind="css: { 'is-visible': isAddPinnedCustomCardVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form w-form-large lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Custom Card</h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickTogglePinnedCustomCardSection(false)}"></button>
                            </div>
                            <div class="w-form-body">
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Card Title</label>
                                        <input type="text" class="input-text" data-bind="value: customCardTitle"/>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Card Linkout</label>
                                        <input type="text" class="input-text" data-bind="value: customCardLinkoutUrl"/>
                                    </div>
                                    <div class="form-group img">
                                        <label for="" class="form-label">Image</label>
                                        <div style="width: 200px; height: 200px; overflow: hidden;">
                                            ${ this.imageWidget.getHtmlBuild() }
                                        </div>
                                    </div>
                                </div>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Description</label>
                                        <textarea id="customCardDescription" class="input-textarea"></textarea>
                                    </div>
                                </div>
                            </div>
                        
                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedCustomCardItem }, text: 'Add'">Add to List</button>
                                <button type="button" data-bind="event: { click: onClickTogglePinnedCustomCardSection(false)}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isPinnedListingPageSectionVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Hub Page</h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, null, false, false)}"></button>
                            </div>
                            <div class="form-body">
                                <div class="form-group">
                                    ${ this.listingPageFilter.getHtmlBuild() }
                                </div>
                                <div class="form-group" data-bind="visible: isAlternateTitleVisible()">
                                        <label class="form-label icon i-overwrite">Alternate Title</label>
                                        <input type="text" class="input-text" data-bind="value: listingPageAlternateTitle"/>
                                </div>
                                <div class="form-group" data-bind="visible: isShowMoreVisible()">
                                        ${ this.showMoreListingPageFilter.getHtmlBuild() }
                                </div>
                            </div>
                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedListingPage }, text: 'Add'">Add to List</button>
                                <button type="button" data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, null, false, false)}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {

        this.pinnedArticles = new pinnedArticles_template('pinnedArticles', this.getTemplateViewModel(), this.caller);
        this.pinnedArticles.setMaximum(8);

        this.filterSidebarLinksListingPage = new filterListingPage_template("filterSidebarLinksListingPage", this.getTemplateViewModel(), this.caller);
        this.filterSidebarLinksListingPage.setPlaceholder('Listing Page');

        this.filterSidebarLinksArticle = new filterAutocomplete_template('filterSidebarLinksArticle', this.getTemplateViewModel(), this.caller);
        this.filterSidebarLinksArticle.setAddNewOptionEnabled(false);
        this.filterSidebarLinksArticle.setHasDisplayNameComplement(false);
        this.filterSidebarLinksArticle.setNumberOfChars( 3 );
        this.filterSidebarLinksArticle.setPlaceholderAndLabel( "Article" );
        this.filterSidebarLinksArticle.setOptionType("title");

        this.sectionTypes = [ {id: 'numerical', name: 'Numbered'}, {id: 'list', name: 'Bullet Point'}];

        this.filterSectionType = new filterDropdown_template('filterSidebarLinksSectionType', this.getTemplateViewModel(), this.caller);
        this.filterSectionType.setOptions(this.sectionTypes);

        this.listingPageFilter = new filterListingPage_template("filterListingPage", this.getTemplateViewModel(), this.caller);
        this.listingPageFilter.setPlaceholder("Main Hub Page");
        this.listingPageFilter.setShowDetails(true);
        this.listingPageFilter.setIsLoadingAnimationEnable(true);

        this.showMoreListingPageFilter = new filterListingPage_template("filterShowMoreListingPage", this.getTemplateViewModel(), this.caller);
        this.showMoreListingPageFilter.setPlaceholder('Show More Hub Page');
        this.showMoreListingPageFilter.setShowDetails(true);
        this.showMoreListingPageFilter.setIsLoadingAnimationEnable(true);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller.viewModel, this.caller.getVnAppZone(), this.caller);
        this.imageWidget = new imageWidget_template('custom_card_image', this.getTemplateViewModel(), this);
        this.imageWidget.setMode('single-select');
        this.imageWidget.setCaller(this.imagePickerHelper);
    }

    protected getTemplateName(): string{
        return "configHomePage-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["ww-form", "config-homepage"];
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            sidebarSections: ko.observableArray([]),
            isItemDialogVisible: ko.observable(false),
            isSectionDialogVisible: ko.observable(false),
            isSectionDeleteVisible: ko.observable(false),
            isLinkDeleteVisible: ko.observable(false),
            activeSection: ko.observable(null),
            linkToDelete: ko.observable(null),
            linkToEdit: ko.observable(null),
            sectionToEdit: ko.observable(null),
            linkType: ko.observable('article'),
            sidebarSectionTabTitle: ko.observable(null),
            alternateTitle: ko.observable(''),
            sectionTitle: ko.observable(''),
            maximumPinnedListingPages: ko.observable(25),
            maximumFullListPinnedListingPages: ko.observable(5),
            maximumPinnedHubPagesPreview: ko.observable(2),
            isFullListTabActive: ko.observable(false),
            isHubPagesPreviewTabActive: ko.observable(false),
            isPinnedListingPageSectionVisible: ko.observable(false),
            isAlternateTitleVisible: ko.observable(true),
            isShowMoreVisible: ko.observable(true),
            pinnedListingPages: ko.observableArray([]),
            fullListPinnedListingPages: ko.observableArray([]),
            pinnedHubPagesPreview: ko.observableArray([]),
            listingPageAlternateTitle: ko.observable(''),
            currentSection: ko.observable(null),
            addFeaturedListingPageEnabled: ko.observable(true),
            tagTrendingLogicConfig: ko.observable(null),
            isDbPageRatingEnabled: ko.observable(false),
            isDbSpotlightEnabled: ko.observable(true),
            isDbPageTabActive: ko.observable(false),
            isDbHomeSpotlightPageTabActive: ko.observable(false),
            spotlightTitle: ko.observable(''),
            pinnedDbPages: ko.observableArray([]),
            pinnedDbHomeSpotlightPages: ko.observableArray([]),
            activatePinnedCustomCards: ko.observable(false),
            customCardsSectionTitle: ko.observable(''),
            customCardsMoreLinkoutTitle: ko.observable(''),
            customCardsMoreLinkoutUrl: ko.observable(''),
            isAddPinnedCustomCardVisible: ko.observable(false),
            customCardTitle: ko.observable(''),
            customCardLinkoutUrl: ko.observable(''),
            pinnedCustomCardItems: ko.observableArray([]),
            cardEdited: ko.observable(),
            onClickAddPinnedListingPage: function (data, event) {
                self.onClickAddPinnedListingPage();
            },
            onClickEditPinnedListing: function (data, event) {
                self.onClickEditPinnedListing(data);
            },
            onClickDeletePinnedListingPage: function (data, event) {
                self.onClickDeletePinnedListingPage(data);
            },
            handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                self.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            },
            onFocus: function(data, event){
                self.onFocus(data, event);
            },
            onBlur: function(data, event){
                self.onBlur(data, event);
            },
            onClickCancelHomePageConfig: (data, event) => {
                self.onClickCancelHomePageConfig();
            },
            onClickSaveHomePageConfig: (data, event) => {
                self.onClickSaveHomePageConfig();
            },
            onClickSaveSection: (data) => {
                self.onClickSaveSection();
            },
            onClickDeleteSection: (data) => {
                self.onClickDeleteSection();
            },
            onClickAddLink: (data) => {
                self.onClickAddLink();
            },
            onClickEditLink: (data) => {
                self.onClickEditLink(data);
            },
            onClickEditSection: (data) => {
                self.onClickEditSection(data);
            },
            onClickDeleteLink: (data) => {
                self.onClickDeleteLink(data);
            },
            onClickSaveSidebarFeaturedLinks: (data) => {
                self.onClickSaveSidebarFeaturedLinks();
            },
            onClickShowSectionModal: (data) => {
                self.onClickShowSectionModal();
            },
            onClickShowItemModal: (data) => {
                self.onClickShowItemModal();
            },
            onClickHideItemModal: (data) => {
                self.onClickHideItemModal();
            },
            onClickCancelLinkEdit: (data) => {
                self.onClickCancelLinkEdit(data);
            },
            onClickCancelSectionEdit: (data) => {
                self.onClickCancelSectionEdit();
            },
            onClickSetActiveSection: (value, data, event) => {
                self.onClickSetActiveSection(value);
            },
            onClickConfirmSectionDelete: function (data, event) {
                self.onClickConfirmSectionDelete();
            },
            onClickConfirmLinkDelete: function (data, event) {
                self.onClickConfirmLinkDelete(data);
            },
            onClickCancelLinkDelete: function (data, event) {
                self.onClickCancelLinkDelete()
            },
            onClickCancelSectionDelete: function (data, event) {
                self.setIsSectionDeleteDialogVisible(false)
            },
            onClickToggleListingPagePinnedSection: function (section, value, type, data, event) {
                //alert(JSON.stringify(arguments));
                self.setIsPinnedListingPageSectionDialogVisible(section, value, type);
            },
            onClickToggleHubPage2HubPreviewSection: function (section, value, type, data, event) {

                self.setIsPinnedListingPageSectionDialogVisible(section, value, type);
            },
            onClickTogglePinnedCustomCardSection: function (data, event) {
                self.onClickTogglePinnedCustomCardSection(data);
            },
            onClickAddPinnedCustomCardItem: function (data, event) {
                self.onClickAddPinnedCustomCardItem();
            },
            onClickDeletePinnedCustomCardItem: function (data, event) {
                self.onClickDeletePinnedCustomCardItem(data);
            },
            onClickEditPinnedCustomCardItem: function (data, event) {
                self.onClickEditPinnedCustomCardItem(data);
            },
            dragStart: (data, event) => { self.startDrag(data, event); },
            dragEnd: (data) => { data.dragging(false); },
            reorderSortable: (event, dragData, zoneData) => { self.reorderSortable(event, dragData, zoneData); }
    };
    }

    public getViewModelForRequest(){

        return {
            pinnedArticles: this.getPinnedArticles(),
            pinnedListingPages: this.getPinnedListingPages(),
            pinned2HubPreviewPages: this.getPinnedHubPagesPreviewPages(),
            isDbPageRatingEnabled: this.getTemplateViewModel().isDbPageRatingEnabled(),
            isDbSpotlightEnabled: this.getTemplateViewModel().isDbSpotlightEnabled(),
            pinnedDbPages: this.getPinnedDbPages(),
            pinnedDbHomeSpotlightPages: this.getPinnedDbHomeSpotlightPages(),
            pinnedCustomCardsSection: this.getPinnedCustomCardsSection()
        };
    }

    public setPinnedArticles(articles){

        let data = [];

        for (let item of articles){

            let pinnedArticle : pinnedArticle = {

                id:             item.id,
                idArticle:      item.emakiArticle.id,
                reference:      item.emakiArticle.reference,
                article:        item.emakiArticle,
                alternateTitle: item.alternateTitle,
                pinnedHours:    '',
                position:       item.position,
                expire:         item.expire,
                timeLeft:       (item.timeLeft) ? item.timeLeft : '',
                enableEdit:     false,
            }

            data.push(pinnedArticle)
        }

        this.pinnedArticles.setArticles(data)
    }

    public getPinnedArticles(){

        let data = [];
        let articles = this.pinnedArticles.getArticles();
        for (let item of articles){

            let pinnedArticle = {

                id:              item.id,
                idEmakiArticle:  item.idArticle,
                emakiArticle:    item.article,
                alternateTitle:  item.alternateTitle,
                expire:          item.expire,
                pinnedHours:     item.pinnedHours,
                position:        item.position
            }

            data.push(pinnedArticle)
        }

        return data;
    }

    public setArticleFilterAutocomplete(idElement, articles) {

        this.pinnedArticles.articleFilter.setOptions(articles)
    }

    public setPinnedListingPages(listingPages){

        let pinnedListingPages = [];
        let fullPinnedListingPages = [];
        let hubPreviewListingPages = [];
        let pinnedDbPages = [];
        let addFeaturedListingPageEnabled = true;

        for(let x in listingPages){

            let id = 'limitedFilterShowMoreListingPage';
            if(listingPages[x].isFullList){
                id='fullFilterShowMoreListingPage'
            }
            if (listingPages[x].type == "hubPreview") {
                id = 'hubPreviewFilterShowMoreListingPage';
            }

            let filter = new filterListingPage_template(id+(x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');
            filter.setIsLoadingAnimationEnable(true);

            let pinnedListingPage = {

                id:                         listingPages[x].id,
                idListingPage:              listingPages[x].idListingPage,
                listingPage:                listingPages[x].listingPage,
                idShowMoreListingPage:      listingPages[x].idShowMoreListingPage,
                showMoreListingPage:        listingPages[x].showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages[x].position,
                dateCreated:                listingPages[x].dateCreated,
                alternateTitle:             listingPages[x].alternateTitle,
                enableEdit:                 false,
                isFullList:                 listingPages[x].isFullList,
                isHubPreview:               (listingPages[x].type == "hubPreview"),
                isDbPage:                   (listingPages[x].type == "hubRating"),
                isDbHomeSpotlightPage:      (listingPages[x].type == "homeSpotlight"),
                type:                       listingPages[x].type,
                idTags:                     listingPages[x].listingPage && listingPages[x].listingPage.tags ? listingPages[x].listingPage.tags : [],      
            }

            if(listingPages[x].showMoreListingPage){

                let showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            if(listingPages[x].isFullList){
                fullPinnedListingPages.push(pinnedListingPage);
            }else if (listingPages[x].type == "hubPreview") {
                hubPreviewListingPages.push(pinnedListingPage);
            } else if (listingPages[x].type == "hubRating") {
                pinnedDbPages.push(pinnedListingPage);  
            }
            else {
                pinnedListingPages.push(pinnedListingPage);
            }

            if (listingPages[x].type == "featured") {
                addFeaturedListingPageEnabled = false;
            }

        }

        this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

        this.getTemplateViewModel().pinnedListingPages(pinnedListingPages);
        this.getTemplateViewModel().fullListPinnedListingPages(fullPinnedListingPages);
        this.getTemplateViewModel().pinnedHubPagesPreview(hubPreviewListingPages);
        this.getTemplateViewModel().pinnedDbPages(pinnedDbPages);
    }

    public getPinnedListingPages(){
        let addFeaturedListingPageEnabled = true;

        this.updatePinnedListingPagePosition();
        this.updateFullListPinnedListingPagePosition();
        let pinnedListingPageIds = [];
        const listingPages = [...this.getTemplateViewModel().pinnedListingPages(), ...this.getTemplateViewModel().fullListPinnedListingPages()]

        for (let i = 0; i < listingPages.length; i++) {

            let item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle : listingPages[i].alternateTitle,
                position :  listingPages[i].position,
                isFullList :  listingPages[i].isFullList,
                type: listingPages[i].type,
            }

            if (listingPages[i].type == "featured") {
                addFeaturedListingPageEnabled = false;
            }

            pinnedListingPageIds.push(item)
        }

        this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

        return  pinnedListingPageIds;
    }

    public updatePinnedHubPagesPreviewPosition(){

        let pinnedHubPagesPreview = this.getTemplateViewModel().pinnedHubPagesPreview();

        for (let i = 0; i < pinnedHubPagesPreview.length; i++) {

            pinnedHubPagesPreview[i].position =  i + 1;
        }

        this.getTemplateViewModel().pinnedHubPagesPreview([]);
        this.getTemplateViewModel().pinnedHubPagesPreview(pinnedHubPagesPreview);
    }

    public getPinnedHubPagesPreviewPages(){

        this.updatePinnedHubPagesPreviewPosition();

        let pinnedHubPagesPreviewIds = [];
        const listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();

        for (let i = 0; i < listingPages.length; i++) {

            let item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle : listingPages[i].alternateTitle,
                position :  listingPages[i].position,
                isHubPreview :  listingPages[i].isHubPreview,
                type: listingPages[i].type,
            }

            pinnedHubPagesPreviewIds.push(item)
        }

        return  pinnedHubPagesPreviewIds;
    }

    public updatePinnedDbPagesPosition(){

        let pinnedDbPages = this.getTemplateViewModel().pinnedDbPages();

        for (let i = 0; i < pinnedDbPages.length; i++) {

            pinnedDbPages[i].position =  i + 1;
        }

        this.getTemplateViewModel().pinnedDbPages([]);
        this.getTemplateViewModel().pinnedDbPages(pinnedDbPages);
    }
    
    public getPinnedDbPages(){

        this.updatePinnedDbPagesPosition();

        let pinnedDbPageTagIds = [];
        const pinnedDbPages = this.getTemplateViewModel().pinnedDbPages();

        for (let i = 0; i < pinnedDbPages.length; i++) {

            let item = {
                idListingPage: pinnedDbPages[i].idListingPage,
                idShowMoreListingPage: null,
                alternateTitle : '',
                position :  pinnedDbPages[i].position,
                isHubPreview :  pinnedDbPages[i].isHubPreview,
                type: pinnedDbPages[i].type,
            }

            pinnedDbPageTagIds.push(item)
        }

        return  pinnedDbPageTagIds;
    }

    public getPinnedDbHomeSpotlightPages(){

        this.updatePinnedDbPagesPosition();

        let pinnedDbPageTagIds = [];
        const pinnedDbHomeSpotlightPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        const spotlightTitle = this.getTemplateViewModel().spotlightTitle();

        for (let i = 0; i < pinnedDbHomeSpotlightPages.length; i++) {
            let idTag = pinnedDbHomeSpotlightPages[i].idTags[0] ? pinnedDbHomeSpotlightPages[i].idTags[0] : null;

            if(!idTag){
                idTag = pinnedDbHomeSpotlightPages[i].listingPage ? pinnedDbHomeSpotlightPages[i].listingPage.tags[0] : null;
            }
            
            if(idTag){
                pinnedDbPageTagIds.push(idTag)
            }
        }

        return  {title: spotlightTitle, idTags: pinnedDbPageTagIds};
    }

    public setPinnedDbSpotlight(data){
        const title = data.title;
        const listingPages = data.listingPages;
        const pinnedListingPages = [];

        for(let x in listingPages){

            let id = 'spotlightShowMoreListingPage';

            let filter = new filterListingPage_template(id+(x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');
            filter.setIsLoadingAnimationEnable(true);

            let pinnedListingPage = {

                id:                         listingPages[x].id,
                name:                       listingPages[x].name,
                permalink:                  listingPages[x].permalink,
                idListingPage:              listingPages[x].id,
                listingPage:                listingPages[x],
                idShowMoreListingPage:      listingPages[x].idShowMoreListingPage,
                showMoreListingPage:        listingPages[x].showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages[x].position,
                dateCreated:                listingPages[x].dateCreated,
                alternateTitle:             listingPages[x].alternateTitle,
                enableEdit:                 false,
                isFullList:                 listingPages[x].isFullList,
                isHubPreview:               false,
                isDbPage:                   false,
                isDbHomeSpotlightPage:      true,
                type:                       listingPages[x].type,
                idTags:                     listingPages[x].tags,      
            }

            pinnedListingPages.push(pinnedListingPage);
        }

        this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
        this.getTemplateViewModel().pinnedDbHomeSpotlightPages(pinnedListingPages);
        this.getTemplateViewModel().spotlightTitle('');
        this.getTemplateViewModel().spotlightTitle(title);
    }

    public setFilterListingPagesAutoComplete(listingPages: Array<HubPageSearchResult>, listingPageIdElement: string): void {

        switch (listingPageIdElement) {
            case 'filterListingPage':
                this.listingPageFilter.setOptions(listingPages);
                break;
            case 'filterShowMoreListingPage':
                this.showMoreListingPageFilter.setOptions(listingPages);
            case 'filterSidebarLinksListingPage':
                this.getTemplateViewModel().filterSidebarLinksListingPage.listingPages(listingPages);
            default:
                this.filterSimpleOnAutoComplete(listingPages, listingPageIdElement)
        }
    }

    protected onClickCancelHomePageConfig() {

        this.caller.cancelHomePageConfig();
    }

    protected onClickSaveHomePageConfig() {

        this.caller.saveHomePageConfig();
    }

    protected onClickAddSidebarLinks() {

        let sidebarLinks = this.getTemplateViewModel().sidebarLinks();

        let link = -1;
        if(sidebarLinks.length > 0) {
            link = sidebarLinks.findIndex(e => e.title.toLowerCase() == this.getTemplateViewModel().sectionTitle().toLowerCase() && e.type.toLowerCase() == this.getTemplateViewModel().sectionType().toLowerCase());
        }
        if(link == -1){
            sidebarLinks.push({title: this.getTemplateViewModel().sectionTitle(), style: this.filterSectionType.getTemplateViewModel().selectedOption, links: this.getTemplateViewModel().sidebarLinks(), position: sidebarLinks.length + 1})
        }

        this.getTemplateViewModel().sidebarLinks(sidebarLinks);
    }

    protected setFiltersArticleAutocompleteOptions(articles){

        this.filterSidebarLinksArticle.setOptions(articles);
    }

    public onClickSaveSection(){

        let sidebarSections = this.getTemplateViewModel().sidebarSections();

        let index = 0;
        let sectionType = this.sectionTypes.find(e => e.id == this.filterSectionType.getTemplateViewModel().selectedOption())
        let sectionTypeTitle = sectionType.name;
        if(this.getTemplateViewModel().sidebarSections().length > 0 && this.getTemplateViewModel().sectionToEdit() > -1) {
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionTitle =  this.getTemplateViewModel().sectionTitle();
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionType = this.filterSectionType.getTemplateViewModel().selectedOption();
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionTypeTitle = sectionTypeTitle;
            this.getTemplateViewModel().activeSection(this.getTemplateViewModel().sectionToEdit())
            this.getTemplateViewModel().sectionToEdit(null);
        } else {
            sidebarSections.push({dragging: ko.observable(false),
                value: {
                    sectionTitle: this.getTemplateViewModel().sectionTitle(),
                    sectionType: this.filterSectionType.getTemplateViewModel().selectedOption(),
                    sectionTypeTitle:  sectionTypeTitle,
                    links: ko.observableArray([]),
                    position: sidebarSections.length + 1
                }
            })
            this.getTemplateViewModel().activeSection(sidebarSections.length - 1)

        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsSectionDialogVisible(false)
        this.clearSectionFields();
    }

    public onClickConfirmSectionDelete(){

        let sidebarSections = this.getTemplateViewModel().sidebarSections();

        let index = this.getTemplateViewModel().activeSection()
        if(index != -1) {
            sidebarSections.splice(index, 1);
        }

        let activeSection = null;
        if(index > 0) {
            activeSection = index - 1;
        } else if(index == 0){
            activeSection = 0
        }
        this.getTemplateViewModel().activeSection(activeSection)
        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsSectionDeleteDialogVisible(false)
    }

    public onClickAddLink(){

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();
        let linkToEdit = this.getTemplateViewModel().linkToEdit();
        let section = sidebarSections[activeSection]
        if(section){
            let reference = '';
            let linkType = this.getTemplateViewModel().linkType();
            let alternateTitle = this.getTemplateViewModel().alternateTitle();

            let article = null;
            let listingPage = null;
            let title = null;

            if(linkType == 'article') {
                 article = this.filterSidebarLinksArticle.getTemplateViewModel().optionObj();

                 if(article){
                    reference = article.reference;
                    title = article.name;
                }
            } else {
                listingPage = this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj();
                if(listingPage){
                    reference = listingPage.id + '';
                    title = listingPage.name;
                }
            }

            let links = sidebarSections[activeSection].value.links();
            if(linkToEdit == null || linkToEdit == -1) {
                links.push({dragging: ko.observable(false) ,value: {type: linkType, alternateTitle: alternateTitle, reference: reference, title: title, articleObj: article, listingPageObj: listingPage}});
            } else {
                links[linkToEdit] = {dragging: ko.observable(false) ,value: {type: linkType, alternateTitle: alternateTitle, reference: reference, title: title, articleObj: article, listingPageObj: listingPage}};
            }
            sidebarSections[activeSection].value.links([]);
            sidebarSections[activeSection].value.links(links);

            this.clearAddLinkFields()

        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsItemDialogVisible(false)
    }

    private clearAddLinkFields(){

        this.getTemplateViewModel().alternateTitle(null);
        this.filterSidebarLinksArticle.clearInput()
        this.filterSidebarLinksListingPage.getTemplateViewModel().listingPage('');
        this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj(null);
        this.getTemplateViewModel().linkType(null);
        this.getTemplateViewModel().linkToEdit(null)
    }

    private clearSectionFields(){

        this.getTemplateViewModel().sectionTitle(null);
        this.filterSectionType.setSelectedOption(null);
        this.filterSidebarLinksListingPage.clearInput();
    }

    protected onClickSaveSidebarFeaturedLinks(){

        this.caller.saveSidebarFeaturedLinksConfig()
    }

    protected setSidebarSectionTabTitle(title) {

        this.getTemplateViewModel().sidebarSectionTabTitle(title)
    }

    protected setSidebarFeaturedLinks(sections){

        for(let section of sections){
            console.log
            let sectionType = this.sectionTypes.find(e => e.id == section.sectionType)
            let sectionTypeTitle = sectionType.name;
            section.sectionTypeTitle = sectionTypeTitle;
            let x = this.toDraggables(section.links);
            console.log(x)
            section.links = ko.observableArray(x);
        }

        this.getTemplateViewModel().sidebarSections(this.toDraggables(sections))
        if(sections.length > 0){
            this.getTemplateViewModel().activeSection(0);
        }
    }

    public onClickEditLink(data){

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if(section){
            let link = section.value.links().find(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            let linkIndex = section.value.links().findIndex(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            this.getTemplateViewModel().linkToEdit(linkIndex)
            if(link) {
                this.getTemplateViewModel().linkType(data.value.type);
                this.getTemplateViewModel().alternateTitle(data.value.alternateTitle);
                if (data.value.type == 'article') {
                    this.filterSidebarLinksArticle.getTemplateViewModel().optionObj(data.value.articleObj);
                } else if (data.value.type == 'listing_page') {
                    this.filterSidebarLinksListingPage.getTemplateViewModel().listingPage(data.value.listingPageObj.name + ' (' + data.value.listingPageObj.permalink + ')');
                    this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj(data.value.listingPageObj)
                }
            }
        }
        this.setIsItemDialogVisible(true)
    }

    public onClickEditSection(data){

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if(section){
            this.getTemplateViewModel().sectionTitle(section.value.sectionTitle)
            this.getTemplateViewModel().sectionToEdit(activeSection)
            this.filterSectionType.setSelectedOption(section.value.sectionType)

        }
        this.setIsSectionDialogVisible(true)
    }

    public onClickConfirmLinkDelete(data) {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();
        let index = this.getTemplateViewModel().linkToDelete();
        if(index > -1){
            sidebarSections[activeSection].value.links.splice(index, 1);
        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsLinkDeleteDialogVisible(false)
    }

    public onClickShowSectionModal() {

        this.getTemplateViewModel().sectionToEdit(-1)
        this.setIsSectionDialogVisible(true)
    }

    protected onClickHideSectionModal() {

        this.getTemplateViewModel().activeSection(0)
        this.setIsSectionDialogVisible(false)
    }

    public onClickShowItemModal() {

        this.setIsItemDialogVisible(true)
    }

    protected onClickHideItemModal() {

        this.setIsItemDialogVisible(false)
    }

    public onClickCancelLinkEdit(data) {

        this.clearAddLinkFields();
        this.setIsItemDialogVisible(false)
    }

    public onClickCancelSectionEdit() {

        this.clearSectionFields();
        this.setIsSectionDialogVisible(false)
    }

    public onClickSetActiveSection(index) {

        this.getTemplateViewModel().activeSection(index);
    }

    public setIsItemDialogVisible(isItemDialogVisible) {

        this.getTemplateViewModel().isItemDialogVisible(isItemDialogVisible)
    }

    public setIsSectionDialogVisible(isSectionDialogVisible) {

        this.getTemplateViewModel().isSectionDialogVisible(isSectionDialogVisible)
    }

    public setIsSectionDeleteDialogVisible(isSectionDeleteVisible) {

        this.getTemplateViewModel().isSectionDeleteVisible(isSectionDeleteVisible)
    }

    public setIsPinnedListingPageSectionDialogVisible(section, bool, value) {

        this.getTemplateViewModel().isPinnedListingPageSectionVisible(bool);
        this.getTemplateViewModel().isFullListTabActive(value);
        this.getTemplateViewModel().currentSection(section);
        this.getTemplateViewModel().isHubPagesPreviewTabActive((section == 'hubPreview'));
        this.getTemplateViewModel().isDbPageTabActive((section == 'hubRating'));
        this.getTemplateViewModel().isDbHomeSpotlightPageTabActive((section == 'homeSpotlight'));
        this.resetPinnedListingPageFilters();
        if (section == 'featured' || section == 'hubRating' || section=='homeSpotlight') {
            this.getTemplateViewModel().isAlternateTitleVisible(false)
            this.getTemplateViewModel().isShowMoreVisible(false)
        } else {
            this.getTemplateViewModel().isAlternateTitleVisible(true)
            this.getTemplateViewModel().isShowMoreVisible(true)
        }
    }

    public setIsLinkDeleteDialogVisible(isLinkDeleteVisible) {

        this.getTemplateViewModel().isLinkDeleteVisible(isLinkDeleteVisible)
    }

    public onClickDeleteSection() {

        this.setIsSectionDeleteDialogVisible(true)
    }

    public onClickDeleteLink(data) {

        console.log(data)
        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if(section){
            let index = section.value.links().findIndex(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            if(index > -1){
                this.getTemplateViewModel().linkToDelete(index)
            }
        }

        this.setIsLinkDeleteDialogVisible(true)
    }

    public onClickCancelLinkDelete(){

        this.getTemplateViewModel().linkToDelete(null);
        this.setIsLinkDeleteDialogVisible(false)
    }

    public startDrag(data, event){

        console.log(data)
        try{
            this.executeDrag(data, event);

        }catch(err){
            throw new Error(err.message);
        }
    }

    public executeDrag(data, event) {

        if (event.srcElement.className.indexOf('i-move') !== -1) {
            data.dragging(true);
            return true;
        } else {
            throw new Error('drag only allowed from the handle');
        }
    }

    private toDraggables(values) {
        return ko.utils.arrayMap(values, function (value) {
            return {
                value: value,
                dragging: ko.observable(false),
            };
        });
    }

    public reorderSortable(event, dragData, zoneData): void{

        if(dragData !== zoneData.item){

            var zoneDataIndex = zoneData.items.indexOf(zoneData.item);
            zoneData.items.remove(dragData);
            zoneData.items.splice(zoneDataIndex, 0, dragData);
        }
    }


    public updatePinnedListingPagePosition(){

        let pinnedListingPages = this.getTemplateViewModel().pinnedListingPages();

        for (let i = 0; i < pinnedListingPages.length; i++) {

            if (pinnedListingPages[i].type == "featured") {
                pinnedListingPages[i].position =  1;
            } else {
                pinnedListingPages[i].position =  i + 1;
            }
        }

        this.getTemplateViewModel().pinnedListingPages([]);
        this.getTemplateViewModel().pinnedListingPages(pinnedListingPages);
    }

    public updateFullListPinnedListingPagePosition(){

        let fullListPinnedListingPages = this.getTemplateViewModel().fullListPinnedListingPages();

        for (let i = 0; i < fullListPinnedListingPages.length; i++) {

            fullListPinnedListingPages[i].position =  i + 1;
        }

        this.getTemplateViewModel().fullListPinnedListingPages([]);
        this.getTemplateViewModel().fullListPinnedListingPages(fullListPinnedListingPages);
    }

    public onClickAddPinnedListingPage(section = null){

        let addFeaturedListingPageEnabled = true;

        if(!this.listingPageFilter.getTemplateViewModel().idListingPage()) {
            this.caller.triggerNotification('Main hub page is required!!');
            return;
        }

        if(!this.getTemplateViewModel().isFullListTabActive() && this.getTemplateViewModel().pinnedListingPages().length == this.getTemplateViewModel().maximumPinnedListingPages()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }

        if(this.getTemplateViewModel().isFullListTabActive() && this.getTemplateViewModel().fullListPinnedListingPages().length == this.getTemplateViewModel().maximumFullListPinnedListingPages()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }
        if(this.getTemplateViewModel().isHubPagesPreviewTabActive() && this.getTemplateViewModel().pinnedHubPagesPreview().length == this.getTemplateViewModel().maximumPinnedHubPagesPreview()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if(this.getTemplateViewModel().isFullListTabActive()){
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        }

        if (this.getTemplateViewModel().isHubPagesPreviewTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }
        
        if (this.getTemplateViewModel().isDbPageTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedDbPages();
        }

        if (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        }

        let mainListingPage = this.listingPageFilter.getTemplateViewModel().listingPageObj();
        let showMoreListingPage = this.showMoreListingPageFilter.getTemplateViewModel().listingPageObj();
        let listingPageAlternateTitle = this.getTemplateViewModel().listingPageAlternateTitle();

        let index = this.getListingPageIndex(mainListingPage, listingPages);
        if(index < 0) {

            let id = (this.getTemplateViewModel().isFullListTabActive() ? 'full' : 'limited')+"filterShowMoreListingPage"+(listingPages.length);
            let filter = new filterListingPage_template(id, this.getTemplateViewModel(), this.caller);
            filter.setPlaceholder('Show More Listing Page');
            filter.setShowDetails(true);
            filter.setIsLoadingAnimationEnable(true);

            let newPinnedListingPage = {
                id:                         null,
                idListingPage:              mainListingPage.id,
                listingPage:                mainListingPage,
                idShowMoreListingPage:      null,
                showMoreListingPage:        showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages.length + 1,
                dateCreated:                null,
                alternateTitle:             listingPageAlternateTitle,
                enableEdit:                 false,
                isFullList:                 (this.getTemplateViewModel().isFullListTabActive()),
                isHubPreview:               (this.getTemplateViewModel().isHubPagesPreviewTabActive()),
                isDbPage:                   (this.getTemplateViewModel().isDbPageTabActive()),
                isDbHomeSpotlightPage:      (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()),
                type:                       this.getTemplateViewModel().currentSection(),
                idTags:                     (this.getTemplateViewModel().isDbPageTabActive()) ? JSON.parse(mainListingPage.tags) : []
            };

            if (this.getTemplateViewModel().currentSection() == "featured") {
                addFeaturedListingPageEnabled = false;
                newPinnedListingPage.position = 1;
            }
            this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

            //set value and filter too for vie/edit mode
            if (showMoreListingPage) {

                newPinnedListingPage.idShowMoreListingPage = showMoreListingPage.id;
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(showMoreListingPage.id);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
            }

            listingPages.push(newPinnedListingPage);

            if(this.getTemplateViewModel().isFullListTabActive()){
                this.getTemplateViewModel().fullListPinnedListingPages([]);
                this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
            } else if (this.getTemplateViewModel().isHubPagesPreviewTabActive()) {
                this.getTemplateViewModel().pinnedHubPagesPreview([]);
                this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
            } else if (this.getTemplateViewModel().isDbPageTabActive()) {
                this.getTemplateViewModel().pinnedDbPages([]);
                this.getTemplateViewModel().pinnedDbPages(listingPages);
            } else if (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()) {
                this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
                this.getTemplateViewModel().pinnedDbHomeSpotlightPages(listingPages);
            }  
            else {
                this.getTemplateViewModel().pinnedListingPages([]);
                this.getTemplateViewModel().pinnedListingPages(listingPages);
            }

            this.resetPinnedListingPageFilters();
            this.setIsPinnedListingPageSectionDialogVisible(section, false, '');

        } else {

            this.caller.triggerNotification('Main Hub page already pinned');
        }
    }

    public onClickEditPinnedListing(data){

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if(data.isFullList){
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (data.isHubPreview) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }

        let index = this.getListingPageIndex(data.listingPage, listingPages);
        if(index > -1){
            listingPages[index].enableEdit = true;
        }

        if(data.isFullList){
            this.getTemplateViewModel().fullListPinnedListingPages([]);
            this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
        } else if (data.isHubPreview) {
            for (let i = 0; i < listingPages.length; i++) {
                if (listingPages[i].idListingPage == data.idListingPage) {
                    listingPages[i].enableEdit = true;
                }
            }
            this.getTemplateViewModel().pinnedHubPagesPreview([]);
            this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
        } else{
            this.getTemplateViewModel().pinnedListingPages([])
            this.getTemplateViewModel().pinnedListingPages(listingPages);
        }

    }

    public onClickDeletePinnedListingPage(data){

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if(data.isFullList){
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (data.isHubPreview) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        } else if (data.isDbPage) {
            listingPages = this.getTemplateViewModel().pinnedDbPages();
        } else if (data.isDbHomeSpotlightPage) {
            listingPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        }

        let index = this.getListingPageIndex(data.listingPage, listingPages);
        if(index > -1){
            listingPages.splice(index, 1)
        }

        if(data.isFullList) {
            this.getTemplateViewModel().fullListPinnedListingPages([])
            this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
        } else if (data.isHubPreview) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage)
            this.getTemplateViewModel().pinnedHubPagesPreview([]);
            this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
        } else if (data.isDbPage) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage)
            this.getTemplateViewModel().pinnedDbPages([]);
            this.getTemplateViewModel().pinnedDbPages(listingPages);
        } else if (data.isDbHomeSpotlightPage) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage)
            this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
            this.getTemplateViewModel().pinnedDbHomeSpotlightPages(listingPages);
        }  
        else{
            this.getTemplateViewModel().pinnedListingPages([])
            this.getTemplateViewModel().pinnedListingPages(listingPages);
        }

        if (data.type == "featured") {
            this.getTemplateViewModel().addFeaturedListingPageEnabled(true);
        }
    }

    public getListingPageIndex(data, listingPages){

        return listingPages.findIndex(listingPage => listingPage.idListingPage == data.id);
    }

    public resetPinnedListingPageFilters(){

        this.listingPageFilter.clearInput();
        this.showMoreListingPageFilter.clearInput();
        this.getTemplateViewModel().listingPageAlternateTitle('');
    }

    public filterSimpleOnAutoComplete(results, idElement){

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if (idElement.startsWith('full')) {
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (idElement.startsWith('hubPreview')) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }
        let index = listingPages.findIndex(listingPage => listingPage.showMoreListingPageFilter.idElement == idElement);
        if(index > -1){
            listingPages[index].showMoreListingPageFilter.setOptions(results);
        }
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public onFocus(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'false')
        }
    }

    public onBlur(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'true')
        }
    }

    protected onClickTogglePinnedCustomCardSection(show, reset = true): void {

        if (show && reset) {
            let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();
            if(pinnedCustomCardItems.length > 5){
                this.caller.triggerNotification('Maximum custom card number reached. Please delete one to add new! ');
                return;
            }
        }

        if (reset) {
            this.getTemplateViewModel().cardEdited(null);
            this.getTemplateViewModel().customCardTitle('');
            this.getTemplateViewModel().customCardLinkoutUrl('');
            this.imageWidget.clearImage();
            if (this.caller.textAreaEditor){
                this.caller.textAreaEditor.setData('');
            }
        }

        this.getTemplateViewModel().isAddPinnedCustomCardVisible(show);
    }

    public onClickAddPinnedCustomCardItem() {
        const vm = this.getTemplateViewModel();
        const cardEdited = vm.cardEdited();
        const pinnedCustomCardItems = vm.pinnedCustomCardItems().slice();
    
        let cardImage = this.imageWidget.getImage();
        if (cardImage) {
            cardImage.uri = cardImage.url;
            cardImage.src = cardImage.url;
        }
    
        const newItem = {
            cardTitle: vm.customCardTitle(),
            cardLinkoutUrl: vm.customCardLinkoutUrl(),
            cardImage: cardImage,
            cardDescription: this.caller.textAreaEditor.getData()
        };
    
        if (cardEdited) {
            const index = pinnedCustomCardItems.findIndex(c =>
                c.cardTitle === cardEdited.cardTitle &&
                c.cardLinkoutUrl === cardEdited.cardLinkoutUrl &&
                c.cardDescription === cardEdited.cardDescription
            );
    
            if (index > -1) {
                pinnedCustomCardItems[index] = newItem;
            } else {
                pinnedCustomCardItems.push(newItem);
            }
    
            vm.cardEdited(null); 
        } else {
            pinnedCustomCardItems.push(newItem);
        }
    
        vm.pinnedCustomCardItems([]);
        vm.pinnedCustomCardItems(pinnedCustomCardItems);
    
        this.onClickTogglePinnedCustomCardSection(false); 
    }

    public onClickDeletePinnedCustomCardItem(data) {
        let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();

        let index = this.getCustomCardIndex(data, pinnedCustomCardItems);
        if(index > -1){
            pinnedCustomCardItems.splice(index, 1)
        }

        this.getTemplateViewModel().pinnedCustomCardItems([])
        this.getTemplateViewModel().pinnedCustomCardItems(pinnedCustomCardItems);
    }

    public getCustomCardIndex(data, pinnedCustomCardItems){
        return pinnedCustomCardItems.findIndex(item => item.cardTitle == data.cardTitle && item.cardLinkoutUrl == data.cardLinkoutUrl);
    }

    public getPinnedCustomCardsSection() {

        if (!this.getTemplateViewModel().activatePinnedCustomCards()) {
            return null;
        }

        let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();
        let data = {
            title: this.getTemplateViewModel().customCardsSectionTitle(),
            moreLinkoutTitle: this.getTemplateViewModel().customCardsMoreLinkoutTitle(),
            moreLinkoutUrl: this.getTemplateViewModel().customCardsMoreLinkoutUrl(),
            items: pinnedCustomCardItems
        };

        return data;
    }

    public setPinnedCustomCardsSection(data) {
        if (data && data.pinnedCustomCards && data.pinnedCustomCards.items && data.pinnedCustomCards.items.length > 0) {
            data = data.pinnedCustomCards; 

            this.getTemplateViewModel().activatePinnedCustomCards(true);
            this.getTemplateViewModel().customCardsSectionTitle(data.title);
            this.getTemplateViewModel().customCardsMoreLinkoutTitle(data.moreLinkoutTitle);
            this.getTemplateViewModel().customCardsMoreLinkoutUrl(data.moreLinkoutUrl);
            this.getTemplateViewModel().pinnedCustomCardItems(data.items);
        }
    }

    public onClickEditPinnedCustomCardItem(data) {
        this.getTemplateViewModel().cardEdited(data);
        this.getTemplateViewModel().customCardTitle(data.cardTitle);
        this.getTemplateViewModel().customCardLinkoutUrl(data.cardLinkoutUrl);
        if(data.cardImage){
            this.imageWidget.setImage(data.cardImage);
        }
        if (this.caller.textAreaEditor){
            this.caller.textAreaEditor.setData(data.cardDescription);
        }

        this.onClickTogglePinnedCustomCardSection(true, false);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configHomePage_template.ts